// extracted by mini-css-extract-plugin
export default {"formatContainer":"ZwUTk34AuUG_H0Gm7TuB","format":"M8Jv_1CuR9YVYkjegLJW","icon":"U_eKMOiynGBdUAxerk8K","lastTable":"u4hECxbsGaZJEXwIoCDd"};